import React, {Component} from 'react';
import {Grid, Row, Col, Form, FormGroup, ControlLabel, Radio, Checkbox} from "react-bootstrap";
import ReactNotify from 'react-notify';
import {TopInputDate} from "../../../../../componentsTopsa/inputs/TopInputs";
import moment from 'moment'
import ValidatorMessages from "../../../../../shared/validatorMessages/ValidatorMessages";
import DateAndTimeUtilities from "../../../../../utilities/DateAndTimeFormat";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import TopDostepnosc from "../../../../../componentsTopsa/dostepnosc/TopDostepnosc";
import {TopButtonAction} from "../../../../../componentsTopsa/buttons/TopButtons";
import ObsadaService from "../ObsadaService";
import {TopAlertUwaga} from "../../../../../componentsTopsa/alerty/TopAlerts";
import TopIf from "../../../../../componentsTopsa/if/TopIf";

export default class ObsadaGenerujContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trasa: null,
            dataOd: null,
            dataDo: null,
            dodatkowaMessage: [],
            czyWszystkieTrasy: false,
            trwaGenerowanie: false,
        };
        this.onChangeTrasa = this.onChangeTrasa.bind(this)
        this.onChangeDataOd = this.onChangeDataOd.bind(this)
        this.onChangeDataDo = this.onChangeDataDo.bind(this)
        this.onClickGeneruj = this.onClickGeneruj.bind(this)
    }

    componentDidMount() {

        this.setState({
            dataOd: moment(this.props.start),
            dataDo: moment(this.props.koniec),
        })
    }

    onChangeTrasa(e) {
        this.setState({trasa: e})
    }

    onChangeDataOd(e) {
        this.setState({dataOd: e})
    }

    onChangeDataDo(e) {
        this.setState({dataDo: e})
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validateMessages;
        arr.push(msg)
        this.setState({validateMessages: arr})
    }

    onClickGeneruj() {

        let poprawne = true;
        this.state.validateMessages = []
        this.setState({dodatkowaMessage: []})

        if (!Boolean(this.state.trasa) && !this.state.czyWszystkieTrasy) {
            poprawne = false;
            this.dodajDoValidatorMessages('Proszę wybrać trasę')
        }

        if (!Boolean(this.state.dataOd) || !Boolean(this.state.dataDo)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Obydwie daty muszą być określone')
        }

        if (DateAndTimeUtilities.formatYYYYMMDD(this.state.dataDo) < DateAndTimeUtilities.formatYYYYMMDD(this.state.dataOd)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Data do nie może być wcześniejsza od daty od')
        }

        if(DateAndTimeUtilities.formatYYYYMMDD(moment()) > DateAndTimeUtilities.formatYYYYMMDD(this.state.dataOd)){
            poprawne=false;
            this.dodajDoValidatorMessages('Nie można wygenerować obsady w wcześniejszym dniu')
        }

         if (poprawne) {

            this.setState({
                trwaGenerowanie: true,
            })

            let obj = {
                "dataDo": DateAndTimeUtilities.formatYYYYMMDD(this.state.dataDo),
                "dataOd": DateAndTimeUtilities.formatYYYYMMDD(this.state.dataOd),
                "idTr": (this.state.czyWszystkieTrasy) ? null : this.state.trasa.idTr
            }

            if (this.state.czyWszystkieTrasy) {
                ObsadaService.generujObsadeDlaWszystkichTras(obj).then(function (response) {
                    if (response.status < 300) {
                        this.refs.notificator.success('Pomyślnie wygenerowano obsadę dla wszystkich tras', "", 3000)
                    }
                    else {
                        this.refs.notificator.error('Wystąpił błąd podczas generowania obsady dla wszystkich tras', "", 3000)
                    }
                    this.setState({dodatkowaMessage: response.data, trwaGenerowanie: false})
                }.bind(this)).catch(function (error) {
                    this.setState({trwaGenerowanie: false})
                    this.refs.notificator.error('Wystąpił błąd podczas generowania obsady dla wszystkich tras', "", 3000)
                }.bind(this))
            }
            else {
                ObsadaService.generujObsade(obj).then(function (response) {
                    if (response.status < 300) {
                        this.refs.notificator.success('Pomyślnie wygenerowano obsadę', "", 3000)
                    }
                    else {
                        this.refs.notificator.error('Wystąpił błąd podczas generowania', "", 3000)
                    }
                    this.setState({dodatkowaMessage: response.data, trwaGenerowanie: false})
                }.bind(this)).catch(function (error) {
                    this.setState({trwaGenerowanie: false})
                }.bind(this))
            }
        }
    }

    formatTrasaSelect(option) {
        return <div><span className={'label label-ebus-primary'}>{option.kodTrasy}</span> {option.nazTr}
            <TopDostepnosc wartoscWarunek={0}
                           wartosc={option.status}
                           czyMarginesLewy={true}/>
        </div>
    }

    render() {

        return (
            <div>
                <TopIf isTrue={this.state.trwaGenerowanie}>
                    <div id={'GenerowanieContainer'}>
                        <h1>
                            <i className={'fa fa-spinner fa-spin'}></i>
                            <div>
                                Trwa generowanie obsady...
                            </div>
                            <h6>
                                Proces ten może potrwać dłuższą chwilę
                            </h6>
                        </h1>
                    </div>
                </TopIf>
                <ReactNotify ref='notificator'/>
                <div>
                    <Row>
                        <Col xs={12} lg={12}>
                            <fieldset>
                                <div className={'fieldset-label'}>Generuj obsadę</div>
                                <Form horizontal={true}>
                                    <FormGroup>
                                        <Col xs={12} lg={3}>
                                            <ControlLabel>Trasa</ControlLabel>
                                            <TopSelect onChange={this.onChangeTrasa}
                                                       value={this.state.trasa}
                                                       options={this.props.trasy}
                                                       valueKey={'idTr'}
                                                       labelKey={'nazTr'}
                                                       valueRenderer={this.formatTrasaSelect}
                                                       optionRenderer={this.formatTrasaSelect}
                                                       disabled={this.state.czyWszystkieTrasy}
                                            />
                                            <Checkbox checked={this.state.czyWszystkieTrasy}
                                                      onClick={() => {
                                                          this.setState({czyWszystkieTrasy: !this.state.czyWszystkieTrasy})
                                                      }}>
                                                Wygeneruj dla wszystkich tras, które są aktywne
                                            </Checkbox>
                                        </Col>
                                        <Col xs={12} lg={2}>
                                            <ControlLabel>Data od</ControlLabel>
                                            <TopInputDate onChange={this.onChangeDataOd} value={this.state.dataOd} horizontal={false}
                                                          minDate={moment(this.props.start)}
                                                          maxDate={moment(this.props.koniec)}
                                            />
                                        </Col>
                                        <Col xs={12} lg={2}>
                                            <ControlLabel>Data do</ControlLabel>
                                            <TopInputDate onChange={this.onChangeDataDo} value={this.state.dataDo} horizontal={false}
                                                          minDate={moment(this.props.start)}
                                                          maxDate={moment(this.props.koniec)}
                                            />
                                        </Col>
                                        <Col xs={12} lg={2}>
                                            <div className={'add-label-margin'}></div>
                                            <TopButtonAction text={'Generuj'} btnSize={'medium'} iconType={'fa fa-group'} btnColor={'primary'}
                                                             onClick={this.onClickGeneruj} btnDisabled={this.state.trwaGenerowanie}/>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup>
                                        <Col xs={12}>
                                            {
                                                Boolean(this.state.dodatkowaMessage.length > 0) ?
                                                    <div>
                                                        <TopAlertUwaga text={'Wystąpiły następujące konflikty'}/>
                                                        {
                                                            this.state.dodatkowaMessage.map(item => {
                                                                return <div>{item.uwaga}</div>
                                                            })
                                                        }
                                                    </div>
                                                    :
                                                    ''
                                            }
                                        </Col>
                                    </FormGroup>
                                    <FormGroup>
                                        <ValidatorMessages messages={this.state.validateMessages}/>
                                    </FormGroup>
                                </Form>
                            </fieldset>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/obsada/ObsadaGeneruj/ObsadaGenerujContainer.js